/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	SubscriptionStorePathParams,
	SubscriptionStoreRequest,
	SubscriptionStoreResponse,
} from '../types/SubscriptionStore'

/**
 * POST /:organisation/profiles/:profile/subscription
 * @see backend/nexus/modules/Billing/Http/Controllers/SubscriptionController.php SubscriptionController::store
 */
export async function subscriptionStore(
	organisation: SubscriptionStorePathParams['organisation'],
	profile: SubscriptionStorePathParams['profile'],
	data: SubscriptionStoreRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<SubscriptionStoreResponse>> {
	return axiosInstance.post(`/${organisation}/profiles/${profile}/subscription`, data, config)
}
